export default __webpack_public_path__ + "static/Mont-BookItalic-ae88ac6fe53a70ddb11ff2940aff3ba2.otf";